import { Component ,AfterViewInit} from '@angular/core'; import { RouterOutlet } from '@angular/router'; import { HeaderComponent } from './components/header/header.component'; import { FooterComponent } from './components/footer/footer.component';
@Component({selector:'app-root',standalone:true,imports:[RouterOutlet,HeaderComponent,FooterComponent],
    template:`<app-header/><main><router-outlet/></main><app-footer/>`}) export class AppComponent implements AfterViewInit {
    ngAfterViewInit(): void {
    this.waitForImages();
  }
  private waitForImages(): void {
    const loader =
      document.getElementById('initial-loader');
    if (!loader) {
      return;
    }
    const images =
      Array.from(
        document.images
      );
    const imagePromises =
      images.map((image) => {
        if (image.complete) {
          return Promise.resolve();
        }
        return new Promise<void>((resolve) => {
          image.addEventListener(
            'load',
            () => resolve(),
            { once: true }
          );
          image.addEventListener(
            'error',
            () => resolve(),
            { once: true }
          );
        });
      });
    Promise.all(imagePromises)
      .then(() => {
        // Give the browser one frame to paint
        // the loaded images before removing loader.
        setTimeout(() => {
          requestAnimationFrame(() => {
            loader.classList.add(
              'loader-hidden'
            );
          });
        },250);
      });
  }


}
